import avatar00 from './00.png'
import avatar01 from './01.png'
import avatar02 from './02.png'
import avatar03 from './03.png'
import avatar04 from './04.png'
import avatar05 from './05.png'
import avatar06 from './06.png'
import avatar07 from './07.png'
import avatar08 from './08.png'
import avatar09 from './09.png'
import avatar10 from './10.png'
import avatar11 from './11.png'
import avatar12 from './12.png'
import avatar13 from './13.png'
import avatar14 from './14.png'
import avatar15 from './15.png'
import avatar16 from './16.png'
import avatar17 from './17.png'
import avatar18 from './18.png'
import avatar19 from './19.png'
import avatar20 from './20.png'
import avatar21 from './21.png'
import avatar22 from './22.png'
import avatar23 from './23.png'
import avatar24 from './24.png'
import avatar25 from './25.png'
import avatar26 from './26.png'
import avatar27 from './27.png'
import avatar28 from './28.png'
import avatar29 from './29.png'
import avatar30 from './30.png'
import avatar31 from './31.png'
import avatar32 from './32.png'
import avatar33 from './33.png'
import avatar34 from './34.png'
import avatar35 from './35.png'
import avatar36 from './36.png'
import avatar37 from './37.png'
import avatar38 from './38.png'
import avatar39 from './39.png'
import avatar40 from './40.png'
import avatar41 from './41.png'
import avatar42 from './42.png'
import avatar43 from './43.png'
import placeholderAvatar from './placeholder.png'
import avatarSmesk from './smesk.riv'

const avatarsMap: Record<string | number, string> = {
  0: avatar00,
  1: avatar01,
  2: avatar02,
  3: avatar03,
  4: avatar04,
  5: avatar05,
  6: avatar06,
  7: avatar07,
  8: avatar08,
  9: avatar09,
  10: avatar10,
  11: avatar11,
  12: avatar12,
  13: avatar13,
  14: avatar14,
  15: avatar15,
  16: avatar16,
  17: avatar17,
  18: avatar18,
  19: avatar19,
  20: avatar20,
  21: avatar21,
  22: avatar22,
  23: avatar23,
  24: avatar24,
  25: avatar25,
  26: avatar26,
  27: avatar27,
  28: avatar28,
  29: avatar29,
  30: avatar30,
  31: avatar31,
  32: avatar32,
  33: avatar33,
  34: avatar34,
  35: avatar35,
  36: avatar36,
  37: avatar37,
  38: avatar38,
  39: avatar39,
  40: avatar40,
  41: avatar41,
  42: avatar42,
  43: avatar43,
  placeholder: placeholderAvatar,
  smesk: avatarSmesk,
}

export default avatarsMap
